import React, { useState, useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
// import "../assets/CSS/login.css";
import API_BASE_URL from "../config";
import { AuthContext } from "../utility/AuthContext";

function Login() {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleLogin = async (e) => {
    setIsSubmitting(true);
    e.preventDefault(); // Prevent page reload

    if (!user || !password) {
      alert("Please enter both username and password.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(API_BASE_URL + "/api/login", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user, password }),
      });

      const data = await response.json();

      if (data.success) {
        login(user, data.role, data.name);
        window.accessToken = data.access_token;
        navigate("/dashboard");
      } else {
        alert(data.error || "Invalid login.");
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Server error : " + error.message);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="d-flex flex-column justify-content-center align-items-center vh-100"
        style={{
          background:
            "linear-gradient(to bottom right, #6c63ff 50%, #162447 50%)",
        }}
      >
        <div className="text-white mb-4 fw-bold">
          <h2>Welcome</h2>
        </div>
        <div
          className="p-5 rounded-4 shadow bg-white text-center"
          style={{ width: "350px" }}
        >
          <h3 className="mb-4 fw-semibold text-secondary">Login</h3>
          <hr />
          <div className="mb-3 text-start">
            <input
              type="text"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              required
              placeholder="Username"
              className="form-control bg-light"
            />
          </div>

          <div className="mb-3 text-start position-relative">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Password"
              className="form-control bg-light"
            />
            <i
              // className="fa-solid fa-eye toggle-password"
              className={`bi ${
                showPassword ? "bi-eye-slash" : "bi-eye"
              } position-absolute`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                right: "15px",
                top: "10px",
                cursor: "pointer",
                zIndex: 2,
              }}
            ></i>
          </div>
          <div className="d-flex justify-content-between mt-4">
            <button
              className="btn btn-primary px-4"
              onClick={handleLogin}
              disabled={isSubmitting}
            >
              Login
            </button>
            <button
              className="btn btn-info text-white px-4"
              onClick={() => navigate("/signup")}
              disabled={isSubmitting}
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
